/**
 * Dependencies
 */
import React, { useState } from 'react';
import DocumentTitle from 'react-document-title';

import { NerdAIChat } from '@nerdwallet/ai-components';
import { Box } from '@nerdwallet/currency/components/Box';
import {
  Experiment,
  ExperimentControl,
  ExperimentVariant,
} from '@nerdwallet/features';
import StructuredContent, {
  StructuredContentProvider,
  createClient,
} from '@nerdwallet/structured-content-core';
import universalCodesplittingFunction from '@nerdwallet/structured-content-core/universal';
import schema from '@nerdwallet/structured-content/schema';

// Local Components
import AnnouncementBanner from '../components/front-page/announcement-banner';
import VerticalComparison from '../components/front-page/vertical-comparison/vertical-comparison';
import CCBest from '../components/front-page/cc-best/cc-best';
import Testimonials from '../components/front-page/testimonials/testimonials';
import NewsArticles from '../components/front-page/news-articles/news-articles-container/news-articles-container';
import RegistrationModule from '../components/front-page/registration-module/registration-module';
import { EXPERIMENTS } from '../experiments';
import chatSuggestedPrompts from '../experiments/chat-suggested-prompts';

// Other Local Dependencies
import {
  verticalComparisonContent,
  ccBestContent,
  testimonialsContent,
  registrationModuleContent,
  campaignHighlightContent,
} from '../lib/front-page-content';
import components from '../lib/nerdai-sc-components';

import styles from './front-page.module.less';
import CampaignHighlight from '../components/front-page/campaign-highlight/campaign-highlight';

const TRAVEL_REDIRECT_TEST_ID =
  EXPERIMENTS.cardfinderTravelRedirectExperiment.id;
const { VARIANT } = EXPERIMENTS.cardfinderTravelRedirectExperiment.variants;
const CHATBOT_TEST_ID = EXPERIMENTS.chatbotExperiment.id;
const { VARIANT: CHATBOT_VARIANT } = EXPERIMENTS.chatbotExperiment.variants;

const FrontPage = () => {
  const documentTitle = 'NerdWallet: Make all the right money moves';
  const [showAnnouncementBanner, setShowAnnouncementBanner] = useState(true);

  const client = createClient({
    components,
    schema,
    codesplittingFunction: universalCodesplittingFunction,
  });

  return (
    <React.Fragment>
      <DocumentTitle title={documentTitle} />
      <Box marginTop={1}>
        <If condition={showAnnouncementBanner}>
          <AnnouncementBanner
            handleOnClose={() => setShowAnnouncementBanner(false)}
          />
        </If>
        <Experiment testName={TRAVEL_REDIRECT_TEST_ID}>
          <ExperimentControl>
            <VerticalComparison {...verticalComparisonContent()} />
          </ExperimentControl>
          <ExperimentVariant name={VARIANT}>
            <VerticalComparison {...verticalComparisonContent(true)} />
          </ExperimentVariant>
        </Experiment>
      </Box>
      <Experiment testName={CHATBOT_TEST_ID} vendor="absmartly">
        <ExperimentVariant name={CHATBOT_VARIANT}>
          <Box className={styles.contentWrapper}>
            <StructuredContentProvider client={client}>
              <NerdAIChat
                StructuredContentComponent={StructuredContent}
                initialSuggestedPrompts={chatSuggestedPrompts}
                variant="home"
              />
            </StructuredContentProvider>
          </Box>
        </ExperimentVariant>
      </Experiment>
      <RegistrationModule {...registrationModuleContent} />
      <Testimonials {...testimonialsContent} />
      <CampaignHighlight {...campaignHighlightContent} />
      <Box marginY={{ mobile: '2', desktop: '3' }}>
        <NewsArticles />
      </Box>
      <CCBest {...ccBestContent} />
    </React.Fragment>
  );
};

FrontPage.displayName = 'FrontPage';
FrontPage.analyticsName = 'nw_home_page';
FrontPage.segmentPageName = 'homepage';

FrontPage.propTypes = {};

export default FrontPage;
